import React from 'react';
import { useAuth } from '../context/AuthContext';

const LoginScreen = () => {
    const { loginWithGoogle, enterMasterMode, loading } = useAuth();

    return (
        <div className="min-h-screen bg-gray-950 flex items-center justify-center p-4">
            <div className="max-w-md w-full bg-gray-900 border border-gray-800 rounded-2xl shadow-2xl p-8 flex flex-col items-center text-center">
                <div className="mb-6">
                    <img
                        src="/logo.png"
                        alt="QuickRoute"
                        className="h-32 w-auto"
                        style={{ filter: 'drop-shadow(0 4px 12px rgba(59, 130, 246, 0.4))' }}
                    />
                </div>

                <p className="text-gray-400 mb-8">Collaborative Football Play Designer</p>

                <div className="w-full space-y-4">
                    <button
                        onClick={loginWithGoogle}
                        disabled={loading}
                        className="w-full bg-white hover:bg-gray-100 text-gray-900 font-bold py-3 px-6 rounded-xl flex items-center justify-center gap-3 transition-all active:scale-95 disabled:opacity-50"
                    >
                        <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="Google" className="w-6 h-6" />
                        Sign in with Google
                    </button>

                    <div className="relative py-4">
                        <div className="absolute inset-0 flex items-center">
                            <div className="w-full border-t border-gray-800"></div>
                        </div>
                        <div className="relative flex justify-center text-sm">
                            <span className="px-2 bg-gray-900 text-gray-500 uppercase tracking-widest font-bold text-[10px]">Dev Bypass</span>
                        </div>
                    </div>

                    <button
                        onClick={enterMasterMode}
                        disabled={loading}
                        className="w-full bg-gray-800 hover:bg-gray-700 text-gray-300 font-bold py-3 px-6 rounded-xl border border-gray-700 transition-all active:scale-95 disabled:opacity-50"
                    >
                        Master Login (Local Mode)
                    </button>
                </div>

                <p className="mt-8 text-xs text-gray-600">
                    Accessing in Local Mode will use your browser's local storage.
                </p>
            </div>
        </div>
    );
};

export default LoginScreen;
